import { render, staticRenderFns } from "./CSideDriverAccountsDetail.vue?vue&type=template&id=378a2628&scoped=true"
import script from "./CSideDriverAccountsDetail.vue?vue&type=script&lang=js"
export * from "./CSideDriverAccountsDetail.vue?vue&type=script&lang=js"
import style0 from "./CSideDriverAccountsDetail.vue?vue&type=style&index=0&id=378a2628&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378a2628",
  null
  
)

export default component.exports